import React, { useState } from "react";

import { useQuery } from "@apollo/client";

import { useHistory } from "react-router-dom";

// @ts-ignore
import { loader } from "graphql.macro";

import EventTable from "./event-table-mui";

const events = loader("../graphql/GetAllEvents.graphql");

interface Props {}

function EventTableContainer(props: Props) {
  // const { history, match } = props;
  const history = useHistory();

  function handleView(value: any, event?: any) {
    if (event) {
      event.stopPropagation();
    }
    history.push(`/${value.id}`);
  }
  function handleEdit(value: any, event?: any) {
    if (event) {
      event.stopPropagation();
    }
    history.push(`/${value.id}/edit`);
  }
  function handleDelete(value: any, event?: any) {
    if (event) {
      event.stopPropagation();
    }
    history.push(`/${value.id}/delete`);
  }

  // const [variables, setVariables] = useState({});

  const [sorting, setSorting] = useState([] as any /*Sorting*/[]); // { columnName: 'StoreCity', direction: 'asc' }
  // const [totalCount, setTotalCount] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  // const [pageSizes, setPageSizes] = useState([5, 10, 15]);
  const [currentPage, setCurrentPage] = useState(0);
  const [hiddenColumnNames, setHiddenColumnNames] = useState([
    "id",
    "command",
    "endDate",
  ] as string[]);
  const [expandedRowIds, setExpandedRowIds] = useState(
    [] as Array<number | string>
  );

  const handleSortingChange = (newSorting: any) => {
    setSorting(newSorting);
  };

  const handleExpandedRowIdsChange = (
    newExpandedRowIds: Array<number | string>
  ) => {
    setExpandedRowIds(newExpandedRowIds);
  };

  const handleCurrentPageChange = (newCurrentPage: number) => {
    setCurrentPage(newCurrentPage);
  };

  const handlePageSizeChange = (newPageSize: number) => {
    setPageSize(newPageSize);
    // const totalPages = Math.ceil(totalCount / newPageSize);
    // const newCurrentPage = Math.min(currentPage, totalPages - 1);
    // setCurrentPage(newCurrentPage);
  };

  const handleHiddenColumnNamesChange = (newHiddenColumnNames: string[]) => {
    setHiddenColumnNames(newHiddenColumnNames);
  };

  // TODO This variables part is Apollo specificy
  const variables: any = {};
  if (sorting && sorting.length > 0) {
    // TODO multisort?
    variables.orderBy = sorting.map(
      (s) => `${s.columnName}_${s.direction.toUpperCase()}`
    )[0];
  }
  if (pageSize && pageSize > 0) {
    variables.first = /* TODO currentPage * ??? */ pageSize;
  }
  // TODO variables.after
  if (currentPage && currentPage > 0) {
    variables.skip = currentPage * pageSize;
  }

  // if (JSON.stringify(variables) !== JSON.stringify(newVariables)) {
  //   setVariables(newVariables);
  // }

  const { data /*, error*/, loading } = useQuery(events, {
    variables,
  });

  // if (error) return `Error! ${error.message}`;

  const dataSource = data ? data.events : undefined;
  const totalElements = data ? data.eventCount : undefined;
  // function changeVariables(newVariables: any) {
  //   if (JSON.stringify(variables) !== JSON.stringify(newVariables)) {
  //     setVariables(newVariables);
  //   }
  // }
  return (
    <>
      {/* {data && ( */}
      <EventTable
        dataSource={dataSource}
        totalElements={totalElements}
        // changeVariables={changeVariables}
        loading={loading}
        onView={handleView}
        onEdit={handleEdit}
        onDelete={handleDelete}
        sorting={sorting}
        onSortingChange={handleSortingChange}
        expandedRowIds={expandedRowIds}
        onExpandedRowIdsChange={handleExpandedRowIdsChange}
        currentPage={currentPage}
        onCurrentPageChange={handleCurrentPageChange}
        pageSize={pageSize}
        onPageSizeChange={handlePageSizeChange}
        hiddenColumnNames={hiddenColumnNames}
        onHiddenColumnNamesChange={handleHiddenColumnNamesChange}
      ></EventTable>
      {/* )} */}
    </>
  );
}

export default EventTableContainer;
